module.exports = __webpack_public_path__ + "static/media/make-salt-lake-logo.6b35605b.jpg";